export default {"src":"/_next/static/media/lock.0a921001.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};